import { z } from 'zod';
import { financingBrokeragePlatformServiceConfigSchema } from '../configurations/FinancingBrokeragePlatformServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderFinancingBrokeragePlatformDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.FINANCING_BROKERAGE_PLATFORM]: financingBrokeragePlatformServiceConfigSchema,
    }),
});

export { servicesProviderFinancingBrokeragePlatformDataSchema };
//# sourceMappingURL=ServicesProviderFinancingBrokeragePlatformData.js.map
